import styled from 'styled-components';
import { DynamicTooltip } from './DynamicTooltip';

const StyledTooltipOverlay = styled.svg<{ $width: string }>`
  position: absolute;
  left: 0;
  z-index: 10;
  height: 100%;
  width: ${({ $width }) => $width};
`;
export const TooltipOverlay = ({
  augmentedLinkData,
  totalCount,
  overlayWidth,
}: {
  augmentedLinkData: any[];
  totalCount: number;
  overlayWidth: string;
}) => {
  return (
    <StyledTooltipOverlay $width={overlayWidth}>
      {augmentedLinkData.map((value) => {
        const { x, y } = value;
        const key = `trackingId${value.trackingId || value.hrefIndex}`;
        let text;

        // If the link has extra data
        if (value.totalCount != null && value.totalCount > 0) {
          // If the link was clicked, we have data on it
          text = `${value.totalCount.toLocaleString()} (${(
            (value.totalCount / totalCount) * 100
          ).toFixed(1)}%)`;
        } else {
          text = '0 (0%)';
        }
        return <DynamicTooltip x={x} y={y} key={key} urlKey={key} text={text} />;
      })}
    </StyledTooltipOverlay>
  );
};
